<!--
  搜索
  lovi 2020-06-16
-->
<template>
  <div class="search-wrap">
    <div
      class="location"
      :class="{ 'text-blue': type == 0 }"
      @click="clickLocation"
    >
      <van-icon name="location-o" />
      <span :class="{ goodsStore: type == 0 }">{{ city }}</span>
      <van-icon v-if="type" name="arrow-down" />
    </div>
    <van-search
      :class="{ white: type == 0 }"
      v-model="searchVal"
      shape="round"
      :placeholder="
        type == 1
          ? $t('personal.enterShippingAddress')
          : $t('personal.enterMerchantCommodity')
      "
    />
  </div>
</template>

<script>
export default {
  props: {
    type: {
      // 0店铺商品 1地址
      type: Number,
      default: 0
    },
    city: {
      // 城市
      type: String,
      default: "深圳市"
    }
  },
  components: {},
  data() {
    return {
      searchVal: ""
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    clickLocation() {
      // 点击位置
      if (this.type == 0) {
        this.$emit("update:locationFlag", true);
      }
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.search-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px;
  height: 48px;
  background: #fff;
  .location {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 90px;
    font-size: 14px;
    overflow: hidden;
    .goodsStore {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .van-icon {
      margin-right: 2px;
      font-size: 16px;
    }
  }
  .van-search {
    flex: 1;
    margin-left: 5px;
    padding: 0;
    &.white {
      .van-search__content {
        background: #fff;
        border: 1.1px solid #dcdcdc;
      }
    }
    .van-cell {
      padding: 3px 8px 3px 0;
    }
    .van-search__content {
      background: #f0f0f0;
    }
    /deep/.van-icon-search {
      color: #bcbcbc;
    }
  }
}
</style>
